'use client';

import type { CSSProperties } from 'react';
import { StarRatingTooltipContent } from './Content';
import { useTooltipPageAction } from './hooks';

export type StarRatingTooltipProps = {
  position?: 'top' | 'bottom' | 'left' | 'right';
  maxWidth?: string | number;
  mobileColor?: string | undefined;
  mobileFontVariant?: CSSProperties | string | undefined;
  segmentActionSection?: string;
};

export const MonetizableStarRatingTooltip = ({
  position = 'bottom',
  maxWidth = 240,
  mobileColor,
  mobileFontVariant,
  segmentActionSection,
}: StarRatingTooltipProps) => {
  const handleTooltipClickPageAction = useTooltipPageAction();
  return (
    <StarRatingTooltipContent
      position={position}
      maxWidth={maxWidth}
      mobileColor={mobileColor}
      mobileFontVariant={mobileFontVariant}
      segmentActionSection={segmentActionSection}
      handleTooltipClickPageAction={handleTooltipClickPageAction}
    />
  );
};
